import { useTranslation } from 'react-i18next';
import { Dropdown } from '@/components/common';
import { useDoctor } from '../doctors';

/**
 * "All doctors" or one doctor's bookings. In the top bar on wide screens and
 * beside the home tabs on narrow ones; both share the filter in DoctorProvider.
 */
export function CalendarFilter({ className }: { className: string }) {
  const { t } = useTranslation();
  const { all, filter, setFilter } = useDoctor();
  if (all.length < 2) return null;
  return (
    <div className={className}>
      <Dropdown
        variant="bar"
        ariaLabel={t('calendar.filter')}
        value={filter ?? ''}
        options={[
          { value: '', label: t('calendar.allDoctors') },
          ...all.map((d) => ({ value: d.id, label: d.name })),
        ]}
        onChange={(v) => setFilter(v || null)}
      />
    </div>
  );
}
